// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#BottomBar {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 3em;
    z-index: 100;
    color: var(--panel-text-color);
    background-color: var(--panel-bg-color);
    box-shadow: 0 -2px 4px rgba(136, 136, 136, 0.5);
    backdrop-filter: blur(3px);
    font-size: 75%;
    display: flex;
    align-items: center;
}

#BottomBar > * {
    margin: 0 0.5em;
}

#BottomBar div.bottombar-scalebar-container {
    min-width: 125px;
}

#BottomBar div.bottombar-scalebar {
    display: inline-block;
    color: var(--panel-text-color);
    text-align: center;
    background-color: rgba(255, 255, 255, 0.5);
    backdrop-filter: blur(3px);
    border-radius: 5px;
    padding: 0.5em;
}

#BottomBar div.bottombar-scalebar-inner {
    border-color: var(--panel-text-color);
    border-style: solid;
    border-width: 0 1px 1px 1px;
}

#BottomBar input.bottombar-mousepos {
    width: 25ch;
    text-align: center;
    border-radius: var(--border-radius) 0px 0px var(--border-radius);
}

#BottomBar .controlgroup select {
    border-radius: 0px var(--border-radius) var(--border-radius) 0px;
}

#BottomBar div.bottombar-scale-combo {
    position: relative;
    width: 10em;
}

#BottomBar span.bottombar-scale-combo-prefix {
    text-align: right;
    width: 2em;
    color: var(--text-color);
}

#BottomBar div.bottombar-scale-combo > div.number-input {
    position: absolute;
    top: 0;
    left: 2em;
    width: 6em;
}

#BottomBar div.bottombar-scale-combo > div.number-input > input {
    text-align: left;
}

#BottomBar span.bottombar-spacer {
    flex: 1 1 auto;
}

#BottomBar span.bottombar-links > a:not(:first-child) {
    border-left: 1px solid var(--panel-text-color);
    margin-left: 0.5em;
    padding-left: 0.5em;
}
`, "",{"version":3,"sources":["webpack://./plugins/style/BottomBar.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,uCAAuC;IACvC,+CAA+C;IAC/C,0BAA0B;IAC1B,cAAc;IACd,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,8BAA8B;IAC9B,kBAAkB;IAClB,0CAA0C;IAC1C,0BAA0B;IAC1B,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,gEAAgE;AACpE;;AAEA;IACI,gEAAgE;AACpE;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,8CAA8C;IAC9C,kBAAkB;IAClB,mBAAmB;AACvB","sourcesContent":["#BottomBar {\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    height: 3em;\n    z-index: 100;\n    color: var(--panel-text-color);\n    background-color: var(--panel-bg-color);\n    box-shadow: 0 -2px 4px rgba(136, 136, 136, 0.5);\n    backdrop-filter: blur(3px);\n    font-size: 75%;\n    display: flex;\n    align-items: center;\n}\n\n#BottomBar > * {\n    margin: 0 0.5em;\n}\n\n#BottomBar div.bottombar-scalebar-container {\n    min-width: 125px;\n}\n\n#BottomBar div.bottombar-scalebar {\n    display: inline-block;\n    color: var(--panel-text-color);\n    text-align: center;\n    background-color: rgba(255, 255, 255, 0.5);\n    backdrop-filter: blur(3px);\n    border-radius: 5px;\n    padding: 0.5em;\n}\n\n#BottomBar div.bottombar-scalebar-inner {\n    border-color: var(--panel-text-color);\n    border-style: solid;\n    border-width: 0 1px 1px 1px;\n}\n\n#BottomBar input.bottombar-mousepos {\n    width: 25ch;\n    text-align: center;\n    border-radius: var(--border-radius) 0px 0px var(--border-radius);\n}\n\n#BottomBar .controlgroup select {\n    border-radius: 0px var(--border-radius) var(--border-radius) 0px;\n}\n\n#BottomBar div.bottombar-scale-combo {\n    position: relative;\n    width: 10em;\n}\n\n#BottomBar span.bottombar-scale-combo-prefix {\n    text-align: right;\n    width: 2em;\n    color: var(--text-color);\n}\n\n#BottomBar div.bottombar-scale-combo > div.number-input {\n    position: absolute;\n    top: 0;\n    left: 2em;\n    width: 6em;\n}\n\n#BottomBar div.bottombar-scale-combo > div.number-input > input {\n    text-align: left;\n}\n\n#BottomBar span.bottombar-spacer {\n    flex: 1 1 auto;\n}\n\n#BottomBar span.bottombar-links > a:not(:first-child) {\n    border-left: 1px solid var(--panel-text-color);\n    margin-left: 0.5em;\n    padding-left: 0.5em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
